<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='btns.refresh' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click='buttonClk' operate='refresh'></e-item>
        <e-item v-if='btns.delete' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("NSMF.delete")' :click='buttonClk' operate='delete'></e-item>
        <e-item v-if='btns.editLicense' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("NSMF.editLicense")' :click='buttonClk' operate='editLicense'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'nssiMenu',
  data() {
    return {
      btns: {
        refresh: true,
        delete: true,
        editLicense: true,           
      },
    };
  },
  mounted() {
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args.item.operate);
    },
  },
};
</script>
